import { AppAreaConfig } from '@/funnels/@types'
import walkingFemale from '../walking/activity-female-walking'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-tai-chi-walking',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking-f', 'age-tai-chi-walking-f'],
		route: {
			path: '/tai-chi-walking-f',
			name: 'tai-chi-walking-funnel',
		},
		overrides: [
			{
				matcher: {
					$or: {
						utm_content: /dategen/,
						utm_term: /dategen/,
					},
				},
				ids: ['creatives-dategen-female-tai-chi-walking', 'age-tai-chi-walking-f'],
			},
		],
	},
	funnel: {
		id: 'ob-female-tai-chi-walking',
		route: {
			path: '/tai-chi-walking-f/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-tai-chi-walking',
		},
		slug: 'activity-female-tai-chi-walking',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
		redirectTo: {
			always: {
				appArea: walkingFemale,
				page: 'focus-area',
			},
		},
	},
}

export default appAreaConfig
